import styled from 'styled-components'

export const StyledLogo = styled.div`
  color: ${({theme}) => theme.text.primary};
  display: inline-grid;
  align-items: center;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  .logo-img {
    height: 65px;
    user-select: none;
    filter: ${({theme}) => theme.brand.logoFilter};
  }
  .logo-text {
    font-size: 32px;
    font-weight: 800;
  }
`;